import { Link } from "react-router-dom";

const DemoReport = () => {
    // const [rowData, setRowData] = useState([]);
    // const [stateId, setStateId] = useState(null)
    // const navigate = useNavigate();
    // const { state } = useLocation();
    // const { data, isLoading } = useFetch(`templates/data/${stateId}`);

    // useEffect(() => {
    //     if (data && Object.keys(data).length > 0) {
    //         setRowData(data);
    //     }
    // }, [data]);

    // useEffect(() => {
    //     if (state !== null && state.id === "") {
    //         setStateId(null);
    //     } else if (state && state.id !== "") {
    //         const id = state.id;
    //         setStateId(id);
    //     }
    // }, [state, stateId]);

    // const handleClick = (rowData) => {
    //     const route = `/assigngoal`;
    //     navigate(route, { state: rowData });
    // };

    // if (isLoading) {
    //     return (
    //         <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
    //             <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    //                 <h1 className="h2 py-2">
    //                     <i className="fa-solid fa-spinner fa-spin"></i>
    //                 </h1>
    //             </div>
    //         </main>
    //     );
    // }

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">
                        <Link to="#">
                            <i className="fa-solid fa-arrow-left"></i>
                        </Link>
                        GHG Report Jan 2022 - Dec 2022
                        {/* {rowData.goal && rowData.goal.goal_name} */}
                    </h1>
                    <button className="btn-orange" /*onClick={() => handleClick(rowData)}*/>
                        PUBLISH
                    </button>
                </div>

                {/* {rowData.goal ? ( */}
                <ul className="reportdetails">
                    {/* {Object.entries(rowData.goal).map(([key, value]) => ( */}
                    <li key={1}>
                        <span>Organization: </span>        <span>Credible Ltd.</span>
                        {/* <span>{key.replace(/_/g, " ")}</span> <span>{value}</span> */}
                    </li>
                    <li key={2}>
                        <span>Author: </span>     <span>George Matthew</span>
                    </li>
                    <li key={3}>
                        <span>Reporting Period: </span>      <span>Jan 2022 to Dec 2022</span>
                    </li>
                    {/* ))} */}
                </ul>
                {/* ) : (
                    <span>There is no data</span>
                )} */}

                <div>
                    <h4 className='tabletitle'>TOTAL EMISSIONS ACROSS ALL FACILITIES</h4>
                    <table className="table goal-details">
                        <thead>
                            <tr>
                                <th>Scope</th>
                                <th>Activity Type</th>
                                <th>Emission(kgCo2e)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* <DepartmentGoalDetail rowDataDepartment={rowData.department} /> */}
                            <tr className="table-light" key={1}>
                                <td>Scope 1</td>
                                <td colspan="1"></td>
                                <td><b>1,106,771.96</b></td>
                            </tr>
                            <tr>
                                <td colspan="1"></td>
                                <td>Mobile Combustion</td>
                                <td>718,364.33</td>
                            </tr>
                            <tr>
                                <td colspan="1"></td>
                                <td>Stationary Combustion</td>
                                <td>388,407.63</td>
                            </tr>
                             <tr className="table-light" key={3}>
                            <td>Scope 3</td>
                            <td colspan="1"></td>
                            <td>516.00</td>
                            </tr>
                            <tr>
                            <td colspan="2"></td>
                            <td>516.00</td>
                            </tr>
                            <tr className="table-light" key={4}>
                                <td colspan="2">Credible Ltd. for Reporting Period:2022-01-01 to 2022-12-31</td>
                                
                                <td>1,202,252.96</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                {/* <div>
                    <h4 className='tabletitle'>Employees</h4>
                    <table className="table goal-details"> */}

                {/* <thead>
                            <tr>
                                <th>Employee Name</th>
                                <th>Begin Date</th>
                                <th>End Date</th>
                                <th>Assigned by</th>
                                <th>Weightage%</th>
                                <th>Target Achieved</th>
                                <th>Status</th>
                            </tr>
                        </thead> */}
                {/* <tbody> */}
                {/* <EmployeeGoalDetail rowDataEmployee={rowData.employees} /> */}
                {/* </tbody> */}
                {/* </table>
                </div> */}
                {/* <div>
                    <h4 className='tabletitle'> Suppliers</h4>
                    <table className="table goal-details">

                        <thead>
                            <tr>
                                <th>Supplier Name</th>
                                <th>Begin Date</th>
                                <th>End Date</th>
                                <th>Assigned by</th>
                                <th>Weightage%</th>
                                <th>Target Achieved</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody> */}
                {/* <SupplierGoalDetail rowDataSupplier={rowData.supplier} /> */}
                {/* </tbody>
                    </table>
                </div> */}
                <div className="facility-inner">
                    <span>*Renewable energy (Solar Energy) from facility(ies) Hyderabad Facility has been offset from the total emission scope 2 </span>
                </div>
            </main>
        </>
    );
}

export default DemoReport